// Spinner.tsx
import React from "react";

const Spinner: React.FC = () => {
  return (
    <div style={{ paddingLeft: "10px", display: "inline-flex" }}>
      <div
        className="spinner-border spinner-border-sm"
        //   style={{ width: "1rem", height: "1rem" }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
